/*
 * Automatisch gratis cadeau (Olaplex N5 30ML) bij bestelling van een 1L fles.
 * Houdt de cart altijd gesynchroniseerd: voegt het cadeau toe zodra een
 * 1L-variant in de cart zit, en verwijdert het weer als die 1L-variant
 * (weer) uit de cart is.
 *
 * Toont daarnaast:
 * - een melding op de productpagina zelf zodra de klant een 1L-variant
 *   selecteert (groen, "je krijgt dit cadeau");
 * - een upsell-melding op de productpagina zodra de klant de kleine
 *   (100ML) variant heeft geselecteerd, met een knop om direct naar de
 *   1L-variant te schakelen (roze, "kies dit om het cadeau te krijgen");
 * - een melding op de winkelwagenpagina zodra het cadeau in de cart zit.
 *
 * Ondersteunt zowel Dawn's eigen variant-picker
 * (<variant-radios>/<variant-selects>) als de variant-picker van de
 * product-app die op deze winkel gebruikt wordt (".bxp-variant-list" /
 * ".bxp-variant-card" / "#bxp-variant-id").
 *
 * Maakt de cadeau-regel in de cart (pagina + drawer) niet-klikbaar, zodat
 * klanten niet per ongeluk naar de (kale) productpagina van het cadeau
 * navigeren.
 */
(function () {
  var GIFT_PRODUCT_HANDLE = 'olaplex-n-5-bond-maintenance-conditioner-30ml-cadeau';
  var GIFT_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/1039/6513/1087/files/olaplex_1_db9cbcae-5c1a-4524-b8bb-3f188d21c4e6.webp?v=1789835676&width=400';

  var TRIGGER_VARIANT_IDS = [
    '58729911451983', // Keratine home kit volume behoud - 1L
    '58729911517519', // Keratine home kit zonder volume behoud - 1L
    '58729911583055', // Proteïne home kit - 1L
    '58729911648591'  // Botox home kit - 1L
  ];
  var GIFT_VARIANT_ID = '58820660625743'; // Olaplex N5 Bond Maintenance Conditioner 30ML (cadeau)

  // Kleine (100ML) variant -> bijbehorende 1L variant, voor de upsell-melding.
  var UPSELL_TARGET = {
    '58729911419215': '58729911451983', // Keratine volume behoud: 100ML -> 1L
    '58729911484751': '58729911517519', // Keratine zonder volume behoud: 100ML -> 1L
    '58729911550287': '58729911583055', // Proteïne: 100ML -> 1L
    '58729911615823': '58729911648591'  // Botox: 100ML -> 1L
  };

  var isSyncing = false;
  var pendingSync = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function notifyCartUpdated(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift-sync', cartData: cartData });
    }
  }

  function syncGift() {
    if (isSyncing) {
      pendingSync = true;
      return;
    }
    isSyncing = true;

    getCart()
      .then(function (cart) {
        var hasTrigger = cart.items.some(function (item) {
          return TRIGGER_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1;
        });

        var giftLine = -1;
        var giftQty = 0;
        cart.items.forEach(function (item, idx) {
          if (String(item.variant_id) === GIFT_VARIANT_ID) {
            giftLine = idx + 1; // 1-based line number for /cart/change.js
            giftQty = item.quantity;
          }
        });

        if (hasTrigger && giftLine === -1) {
          return postJSON('/cart/add.js', {
            items: [
              {
                id: GIFT_VARIANT_ID,
                quantity: 1,
                properties: { _Cadeau: 'Gratis bij bestelling van een 1L fles' }
              }
            ]
          }).then(notifyCartUpdated);
        } else if (!hasTrigger && giftLine !== -1) {
          return postJSON('/cart/change.js', { line: giftLine, quantity: 0 }).then(notifyCartUpdated);
        } else if (hasTrigger && giftQty > 1) {
          return postJSON('/cart/change.js', { line: giftLine, quantity: 1 }).then(notifyCartUpdated);
        }
      })
      .catch(function (e) {
        console.error('free-gift-sync error', e);
      })
      .finally(function () {
        isSyncing = false;
        if (pendingSync) {
          pendingSync = false;
          syncGift();
        }
      });
  }

  var NOTICE_STYLE_ID = 'free-gift-sync-notice-style';
  var NOTICE_CSS =
    '.gift-notice{display:flex;align-items:center;gap:1.1rem;margin:1rem 0;padding:1rem 1.4rem;' +
    'border-radius:10px;background:rgba(0,182,122,0.1);border:1px solid rgba(0,182,122,0.35);' +
    'color:#00875f;font-size:1.4rem;line-height:1.3;}' +
    '.gift-notice--hidden{display:none;}' +
    '.gift-notice__image-wrap{width:76px;height:141px;border-radius:8px;flex-shrink:0;' +
    'overflow:hidden;background:#fff;border:1px solid rgba(0,182,122,0.35);' +
    'position:relative;}' +
    '.gift-notice__image{position:absolute!important;width:239px!important;height:239px!important;' +
    'left:-81px!important;top:-81px!important;max-width:none!important;display:block!important;}' +
    '.gift-notice__icon{font-size:1.8rem;flex-shrink:0;}' +
    '.gift-notice__body{display:flex;flex-direction:column;gap:.3rem;}' +
    '.gift-notice__label{font-size:1.2rem;text-transform:uppercase;letter-spacing:.05rem;' +
    'font-weight:700;opacity:.8;}' +
    '.gift-notice__text{font-weight:600;font-size:1.4rem;}' +
    '.gift-upsell{display:flex;align-items:center;gap:1.1rem;margin:1rem 0;padding:1rem 1.4rem;' +
    'border-radius:10px;background:rgba(194,54,126,0.08);border:1px solid rgba(194,54,126,0.35);' +
    'color:#a21b5c;font-size:1.4rem;line-height:1.3;flex-wrap:wrap;}' +
    '.gift-upsell--hidden{display:none;}' +
    '.gift-upsell__body{display:flex;flex-direction:column;gap:.3rem;flex:1 1 200px;}' +
    '.gift-upsell__label{font-size:1.2rem;text-transform:uppercase;letter-spacing:.05rem;' +
    'font-weight:700;opacity:.85;}' +
    '.gift-upsell__text{font-weight:600;font-size:1.4rem;}' +
    '.gift-upsell__button{flex-shrink:0;border:1px solid #a21b5c;background:#a21b5c;color:#fff;' +
    'font-weight:700;font-size:1.3rem;padding:.7rem 1.3rem;border-radius:6px;cursor:pointer;' +
    'white-space:nowrap;}' +
    '.gift-upsell__button:hover{background:#87164c;}';
  var NOTICE_TEXT = 'Olaplex N°5 Bond Maintenance Conditioner (30ML) bij deze 1L fles!';
  var UPSELL_TEXT = 'Kies de 1L fles en krijg de Olaplex N°5 Conditioner cadeau!';
  var CART_NOTICE_TEXT = 'Je gratis Olaplex N°5 Conditioner (30ML) zit in je bestelling!';

  function ensureNoticeStyle() {
    if (document.getElementById(NOTICE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = NOTICE_STYLE_ID;
    style.textContent = NOTICE_CSS;
    document.head.appendChild(style);
  }

  function buildGiftImage() {
    var imgWrap = document.createElement('div');
    imgWrap.className = 'gift-notice__image-wrap';

    var img = document.createElement('img');
    img.className = 'gift-notice__image';
    img.src = GIFT_IMAGE_URL;
    img.alt = 'Olaplex N°5 Bond Maintenance Conditioner (30ML)';
    img.loading = 'lazy';
    img.width = 239;
    img.height = 239;
    imgWrap.appendChild(img);
    return imgWrap;
  }

  function buildNoticeElement() {
    var el = document.createElement('div');
    el.className = 'gift-notice gift-notice--hidden';
    el.setAttribute('data-gift-notice', '');
    el.setAttribute('role', 'status');

    var body = document.createElement('div');
    body.className = 'gift-notice__body';

    var label = document.createElement('span');
    label.className = 'gift-notice__label';
    label.textContent = '🎁 Gratis cadeau';

    var text = document.createElement('span');
    text.className = 'gift-notice__text';
    text.textContent = NOTICE_TEXT;

    body.appendChild(label);
    body.appendChild(text);

    el.appendChild(buildGiftImage());
    el.appendChild(body);
    return el;
  }

  function buildUpsellElement() {
    var el = document.createElement('div');
    el.className = 'gift-upsell gift-upsell--hidden';
    el.setAttribute('data-gift-upsell', '');
    el.setAttribute('role', 'status');

    var body = document.createElement('div');
    body.className = 'gift-upsell__body';

    var label = document.createElement('span');
    label.className = 'gift-upsell__label';
    label.textContent = '🎁 Gratis cadeau mogelijk';

    var text = document.createElement('span');
    text.className = 'gift-upsell__text';
    text.textContent = UPSELL_TEXT;

    body.appendChild(label);
    body.appendChild(text);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gift-upsell__button';
    button.textContent = 'Naar de 1L fles';
    button.addEventListener('click', function () {
      var targetId = el.getAttribute('data-target-variant-id');
      if (!targetId) return;
      var card = document.querySelector('.bxp-variant-card[data-variant-id="' + targetId + '"]');
      if (card) card.click();
    });

    el.appendChild(body);
    el.appendChild(button);
    return el;
  }

  function insertAfterOnce(anchor, existingAttr, buildFn) {
    var next = anchor.nextElementSibling;
    if (next && next.hasAttribute && next.hasAttribute(existingAttr)) return next;
    var el = buildFn();
    anchor.insertAdjacentElement('afterend', el);
    return el;
  }

  function injectNotices() {
    ensureNoticeStyle();

    // Dawn's native variant picker.
    document.querySelectorAll('variant-radios, variant-selects').forEach(function (anchor) {
      var notice = insertAfterOnce(anchor, 'data-gift-notice', buildNoticeElement);
      insertAfterOnce(notice, 'data-gift-upsell', buildUpsellElement);
    });

    // Third-party variant/bundle picker used on this store ("bxp-*").
    document.querySelectorAll('.bxp-variant-list').forEach(function (anchor) {
      var notice = insertAfterOnce(anchor, 'data-gift-notice', buildNoticeElement);
      insertAfterOnce(notice, 'data-gift-upsell', buildUpsellElement);
    });
  }

  function updateGiftNotices(variantId) {
    var idStr = String(variantId);
    var isTrigger = TRIGGER_VARIANT_IDS.indexOf(idStr) !== -1;
    var upsellTarget = UPSELL_TARGET[idStr];

    document.querySelectorAll('[data-gift-notice]').forEach(function (el) {
      el.classList.toggle('gift-notice--hidden', !isTrigger);
    });

    document.querySelectorAll('[data-gift-upsell]').forEach(function (el) {
      if (upsellTarget) {
        el.setAttribute('data-target-variant-id', upsellTarget);
        el.classList.remove('gift-upsell--hidden');
      } else {
        el.classList.add('gift-upsell--hidden');
      }
    });
  }

  function currentSelectedVariantId() {
    var input = document.querySelector(
      'product-form input.product-variant-id, ' +
      'form input[name="id"].product-variant-id, ' +
      '#bxp-variant-id, ' +
      'form#bxp-form input[name="id"]'
    );
    return input ? input.value : null;
  }

  function refreshNoticeFromDom() {
    var variantId = currentSelectedVariantId();
    if (variantId) updateGiftNotices(variantId);
  }

  function disableGiftLinks() {
    document.querySelectorAll('a[href*="' + GIFT_PRODUCT_HANDLE + '"]').forEach(function (a) {
      if (a.getAttribute('aria-disabled') === 'true') return;
      a.removeAttribute('href');
      a.style.pointerEvents = 'none';
      a.style.cursor = 'default';
      a.setAttribute('aria-disabled', 'true');
      a.setAttribute('tabindex', '-1');
    });
  }

  // Melding op de winkelwagenpagina zodra het cadeau in de cart zit.
  function updateCartPageNotice() {
    var wrap = document.getElementById('main-cart-items');
    if (!wrap || !wrap.parentElement) return;

    getCart().then(function (cart) {
      var hasGift = cart.items.some(function (item) {
        return String(item.variant_id) === GIFT_VARIANT_ID;
      });

      var existing = document.querySelector('[data-gift-cart-notice]');
      if (hasGift) {
        if (!existing) {
          ensureNoticeStyle();
          var el = document.createElement('div');
          el.className = 'gift-notice';
          el.setAttribute('data-gift-cart-notice', '');
          el.setAttribute('role', 'status');

          var body = document.createElement('div');
          body.className = 'gift-notice__body';

          var label = document.createElement('span');
          label.className = 'gift-notice__label';
          label.textContent = '🎁 Gratis cadeau';

          var text = document.createElement('span');
          text.className = 'gift-notice__text';
          text.textContent = CART_NOTICE_TEXT;

          body.appendChild(label);
          body.appendChild(text);

          el.appendChild(buildGiftImage());
          el.appendChild(body);

          wrap.parentElement.insertBefore(el, wrap);
        }
      } else if (existing) {
        existing.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectNotices();
    refreshNoticeFromDom();
    syncGift();
    disableGiftLinks();
    updateCartPageNotice();

    if (typeof MutationObserver !== 'undefined') {
      var giftLinkObserver = new MutationObserver(function () {
        disableGiftLinks();
      });
      giftLinkObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'free-gift-sync') {
          updateCartPageNotice();
          return;
        }
        syncGift();
        disableGiftLinks();
        updateCartPageNotice();
      });

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        injectNotices();
        updateGiftNotices(event.data.variant.id);
      });
    }

    // The "bxp" variant/bundle picker doesn't use Dawn's pub/sub system: it
    // swaps its hidden variant-id input via its own click handler. Re-check
    // shortly after any click on a variant card so our handler runs after
    // the app has finished updating the DOM.
    document.addEventListener('click', function (event) {
      var card = event.target && event.target.closest && event.target.closest('.bxp-variant-card');
      if (!card) return;
      setTimeout(function () {
        injectNotices();
        refreshNoticeFromDom();
      }, 60);
    });

    // Same reasoning for add-to-cart via the bxp form: it does a normal
    // (non-AJAX) form submit, so the cart itself only changes after the
    // resulting page navigation - the DOMContentLoaded handler above then
    // takes care of syncGift() and updateCartPageNotice() on whichever
    // page loads next.
  });
})();
